<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				<span v-if="order!=null" class="red">

					订单编号:{{order.OrderCode }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					借书数量:{{order.BookNums }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					客户信息:{{order.CustomerName +' '+ order.CustomerPhone}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					收货地址:{{order.Destination }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					订单时间:{{order.OrderDate }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">

			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>操作行为</th>
							<th>操作店铺</th>
							<th>操作人</th>
							<th>操作时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in history">
							<td>{{index+1}}</td>
							<td>
								{{i.ActionDesc}}
							</td>

							<td>
								{{i.ShopName}}
							</td>
							<td>
								{{i.Operater}}
							</td>
							<td>
								{{i.OperationTime}}
							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>
	export default {
		name: 'orderyQueryHistory',
		data() {
			return {
				order: null,
				searchBookCode: '',
				getData: {},
				history: [],
				borrowCount: 0,
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.shopID,
				orderID: 0
			}
		},
		created() {
			this.getData = () => {
				this.orderID = this.$route.params.orderID;
				this.$request.request({
					url: 'Query/getOrderByOrderID',
					data: {
						OrderID: this.orderID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.order = res.order;
						this.history = res.order.history;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
			this.getData();

		},
		methods: {},
		computed: {


		},
		watch: {
			$route(n, o) {
				 
				if (n.path.indexOf('orderHistory') == -1) return;
				let nbooksid = n.params.orderID;
				let obooksid = o.params.orderID;
				if (nbooksid != obooksid)
					this.getData();
			}

		}

	}
</script>

<style>
</style>
